import { http } from '../http'

export interface SalaryListData {
  cif: string
}

export interface SalaryList {
  owner: string,
  iban: string,
  pin: string,
  status: string,
  deadline: string,
  pan: string
  fin: string
}
export interface Company {
  customerNo : string;
  account: string,
};


export interface SalaryPosData {
  trnRequestType: string,
  PMTID: string,
  PMT_STATUS: string,
  PMTTYPECODE: string,
  PMTCUSTID: string,
  CUSTCIF: string,
  CUSTNAME: string,
  CUSTTAXID: string,
  CUSTADDR: string ,
  CUSTACC: string,
  CUSTACCFORCOM: string,
  PMTAMOUNT: number,
  COMMISSION: number,
  BENEFACC: string,
  PMTDETAIL: string,
  NOTE: null,
  MAKER_NOTE: string,
  TRANSACTION_EMPLIST: Array<any>
}

export interface SalaryData {
  COMPCIF: string,
  EMPLACC: Array<any>
}

export interface salaryExcelInputData {
  employeeName: string;
  employeeAccount: string;
  employeeAmount: number;
  employeePmtDetail: string;
}

export interface SalaryExcelFile {
  status: any,
  data: {
      fileDetailsList: [
          {
              fileBase64: any;
              pmtid: any;
              fileName: any;
              mimeType: any;
          }
      ];
  }

};

export const getSalaryList = async (cif: String): Promise<SalaryList[]> => {
  const { data } = await http.get<SalaryList[]>(`/moneytransfer/salary/employees-bycif/${cif}`)  
  // const { data } = await http.get<SalaryList[]>(`/moneytransfer/salary/employees-bycif/1629245`)  
  return data
}

export const getSalaryListWithPin = async (cif: String, pin: String): Promise<SalaryList[]> => {
  const { data } = await http.post<any>(`/moneytransfer/salary/employees-byfin/${cif}`, { fin: pin })
  return data
}

export const postSalaryData = async (salaryData: SalaryPosData): Promise<SalaryPosData[]> => {
  const { data } = await http.post<SalaryPosData[]>(`/moneytransfer/salary`, salaryData)
  return data;
}

export const getSalaryDocumentNumber = async (company : Company): Promise<string> => {
  const { data } = await http.get<string>(`customers/${company.customerNo}/accounts/pmtcustid/SALARY_TOTAL`);
  return data;
};
export const checkSalaryData = async (company : Company, account : Company): Promise<any> => {
  const { data } = await http.get<string>(`moneytransfer/salary/check-employee/1629245/AZ31BRES00380194400208519608`);
  // const { data } = await http.get<string>(`moneytransfer/salary/check-employee/${company.customerNo}/${account}`);
  return data;
};
export const checkSalaryList = async (salaryData: SalaryData) => {  
  const { data } = await http.post<string>(`/moneytransfer/salary/by-iban/check`, salaryData);
  // const { data } = await http.get<string>(`moneytransfer/salary/check-employee/${company.customerNo}/${account}`);
  return data;
}

export const getSalaryExcel = async (salaryExcelData: salaryExcelInputData): Promise<SalaryExcelFile> => {

  const { data } = await http.post<SalaryExcelFile>(`file/get-salary-excel`, salaryExcelData);
  return data;
};